import gql from "graphql-tag";
import AnswerablePostFields from "lib/graphql/fragments/engagement/AnswerablePostFields";

export default gql`
  mutation SetPostReplyAnswer($objectId: ID!) {
    setPostReplyAnswer(objectId: $objectId) {
      ...AnswerablePostFields
    }
  }

  ${AnswerablePostFields}
`;
